import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconUsers.c.svg?react';

export const IconUsers = withIconWrapper(ReactComponent);
